// StepProgressBar.jsx
import { motion } from "framer-motion";
import StepItem from "./StepItem";

export default function StepProgressBar({
  step,
  totalSteps,
  setStep,
}) {
  const stepNames = [
    "Basic Details",
    "Address",
    "Aadhaar Card",
    "Education",
    "Achievements",
    "Social Media",
  ];

  const percentage = [
    "10%",
    "20%",
    "30%",
    "40%",
    "50%",
    "60%",
    "70%",
    "80%",
    "90%",
    "100%"
  ];

  return (
    <div className="w-full mb-8 px-4">
      <div className="relative flex items-start justify-between">

        {/* BACKGROUND LINE */}
        <div className="absolute top-4 left-0 right-0 h-2 bg-gray-300 rounded-full z-0" />

        {/* ACTIVE LINE */}
        <motion.div
          className="absolute top-4 left-0 h-2 bg-blue-600 rounded-full z-0"
          initial={{ width: "0%" }}
          animate={{
            width: `calc(${percentage}% + 10%)`,
          }}
          transition={{ duration: 0.4 }}
        />

        {/* STEPS */}
        {stepNames.map((name, idx) => (
          <StepItem
            key={idx}
            name={name}
            stepNumber={idx + 1}
            step={step}
            setStep={setStep}
          />
        ))}
      </div>
    </div>
  );
}